import { MetadataJson } from '@metaplex/js';
import * as anchor from '@project-serum/anchor';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';

const MAINNET = true;

export type StaticMetadata = {
  metadata: {
    name: string;
    symbol: string;
    uri: string;
    seller_fee_basis_points: number;
    creators: {
      address: string;
      share: number;
    }[];
  };
  arweave: MetadataJson;
  mint: string;
  emissionsPerDay: number;
  faction: string;
};

const devnetConstants = {
  mainnet: MAINNET,
  network: WalletAdapterNetwork.Devnet,
  wrappedSol: new anchor.web3.PublicKey(
    'So11111111111111111111111111111111111111112'
  ),
  jungleKey: new anchor.web3.PublicKey(
    '9B399iD1kFwEW7qQo9YuioSMdiXFW9GSp2nZH57GxTUk'
  ),
  rafflesKey: new anchor.web3.PublicKey(
    'GU5bphjemGjKZfAqSFaKR1oR9vXCkBfTUcdgmTXB1sya'
  ),
};

const mainnetConstants = {
  mainnet: MAINNET,
  network: WalletAdapterNetwork.Mainnet,
  wrappedSol: new anchor.web3.PublicKey(
    'So11111111111111111111111111111111111111112'
  ),
  jungleKey: new anchor.web3.PublicKey(
    'HJ655UFugw7kDMqvzGThL9wMpfLtDAPauE6C2w2yjATb'
  ),
  rafflesKey: new anchor.web3.PublicKey(
    '7TyB298ciiTzjfRjQ1pxLEvvRCfmNBD1MRUnV3rzARUk'
  ),
  // rafflesKey: new anchor.web3.PublicKey(
  //   '1fFgiexVprenYb8BdLAVfCZydkBrJkruXdCJ33bN6Tf'
  // ),
};

const constants = MAINNET ? mainnetConstants : devnetConstants;
export default constants;
